import React from 'react';
import { useSiteSettings, resolveMediaUrl } from '../../siteSettings';
import './style.css'

const Footer = (props) => {
    const settings = useSiteSettings();
    return(
        <div className={`site-footer ${props.footer}`} style={settings.footerImage ? { backgroundImage: `url(${resolveMediaUrl(settings.footerImage)})` } : undefined}>
            <div className="container">
                <div className="row">
                    <div className="text">
                        <h2>{settings.coupleNames}</h2>
                        <p>Merci de partager notre bonheur</p>
                    </div>
                </div>
            </div> 
        </div>
    )
}

export default Footer;
